import { Component, OnInit, Input } from '@angular/core';
import { Skins, AllSkins, Skin } from '../../../objects/skins';

@Component({
  selector: 's18-display-skins',
  templateUrl: './display-skins.component.html',
  styleUrls: ['./display-skins.component.scss']
})
export class DisplaySkinsComponent implements OnInit {
  @Input() skins : Skins;

  constructor() { }

  ngOnInit() {
    console.log(this.skins);
    if (this.skins.skinsSummary && !Array.isArray(this.skins.skinsSummary.player)){
      this.skins.skinsSummary.player = Array.of(this.skins.skinsSummary.player);
    }

  }

}
